import React from "react";
import { ImageOrientation } from "@/api/nfts/types";
import Link from "next/link";
import { ShortUser } from "@/api/users/types";
import { getUsersName } from "@/api/users/helpers";
import { ImageTypeHandler } from "@/app/(components)/Basic/ImageTypeHandler";
import { ImagePlaceholder } from "@/app/(components)/Basic/Image/types";
import { DEFAULT_NFT_SIZE } from "@/shared/constants";
import { EndemicUserWrapper } from "@/app/(components)/Basic/EndemicUserWrapper";
import { Marketplaces } from "../../Marketplace/constants";
import ArtworkItemTradeInfo from "../ArtworkItem/ArtworkItemTradeInfo/ArtworkItemTradeInfo";
export interface Props {
  imageSrc: string;
  imageWidth: number;
  imageHeight: number;
  placeholder?: ImagePlaceholder;
  mediaType?: string;
  name: string;
  artist?: ShortUser;
  artistVisible?: boolean;
  orientation: ImageOrientation;
  swap?: boolean;
  id: string;
  marketplace?: Marketplaces;
  price?: string;
  paymentErc20TokenAddress?: string;
  blockchain?: string;
}

const ArtworkMasonryItem = ({
  imageSrc,
  imageWidth,
  imageHeight,
  mediaType,
  placeholder,
  name,
  id,
  artist,
  artistVisible = false,
  marketplace,
  price,
  paymentErc20TokenAddress,
  blockchain,
}: Props) => {
  return (
    <Link
      className="relative w-full md:mb-5 cursor-pointer block"
      href={`/nft/${id}`}
    >
      <div className="relative w-full">
        <ImageTypeHandler
          src={imageSrc}
          placeholder={placeholder}
          type={mediaType}
          alt={name}
          width={imageWidth || DEFAULT_NFT_SIZE}
          height={imageHeight || DEFAULT_NFT_SIZE}
          className={"w-full"}
          grid
        />
      </div>
      <div className="font-light sm:w-auto text-white sm:text-primary absolute md:inset-0 md:flex md:justify-end md:flex-col md:bg-gradient-to-b md:from-[rgba(0,0,0,0)] md:to-[rgba(0,0,0,0.6)] md:transition-opacity md:opacity-0 md:hover:opacity-100 md:p-6">
        <ArtworkItemTradeInfo
          marketplace={marketplace}
          price={price}
          paymentErc20TokenAddress={paymentErc20TokenAddress}
          blockchain={blockchain}
          className="text-primary  md:text-white mb-2"
        />
        <p className="text-[26px] leading-8 text-primary md:font-light md:text-white md:text-[32px] md:leading-[32px]">
          {name}
        </p>
        {artistVisible && artist ? (
          <EndemicUserWrapper id={artist.id}>
            <p className="text-white">by {getUsersName(artist, true)}</p>
          </EndemicUserWrapper>
        ) : null}
      </div>
    </Link>
  );
};

export default ArtworkMasonryItem;
